export const GET_ALL_REPORTS = 'GET_ALL_REPORTS';
export const GET_REPORT_EXCEL = 'GET_REPORT_EXCEL';
export const DELETE_ALL_REPORTS = 'DELETE_ALL_REPORTS';
export const GET_ALL_ACTIVITIES = 'GET_ALL_ACTIVITIES';
export const GET_ALL_MATERIALS = 'GET_ALL_MATERIALS';
export const FINISH_LOADED_NEW_DATA_ON_WORKTIME_PAGE = 'FINISH_LOADED_NEW_DATA_ON_WORKTIME_PAGE';

export function getAllReports(data) {
  return {
    type: GET_ALL_REPORTS,
    payload: data,
  }
}

export function deleteAllReports() {
  return {
    type: DELETE_ALL_REPORTS,
    payload: {},
  }
}

export function getReportExcelFile(data) {
  return {
    type: GET_REPORT_EXCEL,
    payload: data,
  }
}

export function getAllActivities(payload) {
  return {
    type: GET_ALL_ACTIVITIES,
    payload
  }
}

export function getAllMaterials(payload) {
  return {
    type: GET_ALL_MATERIALS,
    payload
  }
}

// this action is used to show new data on worktime page
export function finishedAllActivitiesOnWorkTimePage(payload) {
  return {
    type: FINISH_LOADED_NEW_DATA_ON_WORKTIME_PAGE,
    payload
  }
}



// WEBPACK FOOTER //
// ./src/actions/reports/index.js